// © Microsoft Corporation. All rights reserved.

import { BridgeEventNames, dispatchBridgeEvent } from "./Social.bridge";

import { getExternalURL } from "./urlHelper";
import { isComponentDisabled } from "./themeHelpers";

export function openArticlePage(theme, url, contentId, commentId, target = "_self") {
    const attributes = [];
    attributes["href"] = getExternalURL(url, undefined, commentId);
    attributes["target"] = target;
    if (isComponentDisabled(theme, "articlepage")) {
        attributes["onClick"] = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const idAndMarket = contentId.split("_");
            dispatchBridgeEvent(BridgeEventNames.openDeepLink, {link: `msnnews://application/view?entitytype=Article&contentId=${idAndMarket[0]}&commentId=${commentId}&shouldScrollToComments=true`});
        };
    }
    return attributes;
}